import array_column from "locutus/php/array/array_column";
import ls from "local-storage";
import * as detail from "../page/detail.js";
import { KonfiguraceZbrane as KF } from "./KonfiguraceZbrane.js";
//import { WidgetKosik } from "./WidgetKosik.js";
import { Top } from "./Top.js";
require("@fancyapps/fancybox");

var Kosik = {
  polozky: {}, //--polozky vyhradne pro konfigurator

  _init: function() {
    Lc.h("sssssssssssssssfssss", KF);
    if (KF.vybraneVolby()) this.nactiUlozenePolozky();
    // this.nactiUrlAdresy();
  },

  refresh: function() {
    Lc.f("Kosik:refresh");
    //this.polozky={};
    if (KF.vybraneVolby()) this.nactiUlozenePolozky();
  },

  aktualizujZavisle: function() {
    Lc.f("Kosik:aktualizujZavisle");
    this.refresh();

    Lc.t("ladzo:aktualizaceWidgetuKosiku");
    $(document).trigger("ladzo:aktualizaceWidgetuKosiku");

    Lc.t("ladzo:aktualizacePaneluZbrane");
    $(document).trigger("ladzo:aktualizacePaneluZbrane");
  },

  smazVse: function() {
    ls.remove("ladzo.cz/Kosik/polozky");
  },

  smazVsechnyPolozkyKosiku: function() {
    this.polozky = {};
    ls.set("ladzo.cz/Kosik/polozky", this.polozky);
  },

  smazPolozku: function($priceId) {
    //console.log("smaz", $priceId);
    delete this.polozky[$priceId];
    ls.set("ladzo.cz/Kosik/polozky", this.polozky);
  },

  smazPolozkyDleDatalayeruShoptetu: function() {
    Lc.f("smazPolozkyDleDatalayeruShoptetu");
    Lc.log("polozky", this.polozky);
    let pom = this.polozky;

    var cart = window.getShoptetDataLayer("cart");
    Lc.log("cart", cart);

    /*
const searchIndex = carList.findIndex((car) => car.id==9);
console.log('dfas',searchIndex);
*/
    let searchIndex;
    let $this = this;
    _.forEach(pom, function(Val) {
      //let priceId = parseInt(Val.priceId);
      let priceId = Val.priceId;

      searchIndex = cart.findIndex(pol => pol.priceId == priceId);
      //Lc.log("priceId", priceId);
      //Lc.log("searchIndex", searchIndex);
      if (searchIndex < 0) {
        $this.smazPolozku(priceId);
      }
    });
  },
  zkontrolujPolozkySeShoptetem: function($pom) {
    //console.log("zkontroluj");
    Lc.f("zkontrolujPolozkySeShoptetem");
    let $ret = {};
    let $shoptetCart = window.getShoptetDataLayer("cart") || [];
    if (!$shoptetCart.length) return {};

    //var $this = this;
    //TODO: Zde by šlo dodělat ciskavani code pro produkt

    //let $Smazat = {};
    //let $Nemazat = {};
    _.forEach($pom, function($Val) {
      let $priceId = parseInt($Val.priceId);
      $shoptetCart.forEach(function($E) {
        if ($E.priceId == $priceId) {
          $ret[$priceId] = $Val;
          //$Nemazat[$priceId] = true;
        } else {
          //nelze sm
          //$this.smazPolozku($E.priceId);
          //$Smazat[$priceId] = true;
        }
      });
    });
    //console.log("---smaza--", $Smazat);
    //console.log("---nechat--", $Nemazat);
    /*

    if (!_.isEmpty($Smazat)) {
      _.forEach($Smazat, function($Val, $key) {
        //console.log("$key", $key);
        //console.log("$Val", $Val);
        var $jeOk = $Nemazat[$key] || false;
        if (!$jeOk) {
          $this.smazPolozku($key);
        }
      });
    }
    */
    return $ret;
  },

  nactiUlozenePolozky: function() {
    Lc.f("nactiUlozenePolozky");
    console.log("nactiUlozenePolozky");
    let $pom = ls.get("ladzo.cz/Kosik/polozky");
    //TODO: udělat kontrolu kosiki,, bohužel datalayer se neobnovuje
    //$pom = this.zkontrolujPolozkySeShoptetem($pom);

    if ($pom) {
      this.polozky = $pom;
    }
    return this.polozky;
  },

  ulozPolozku: function($priceId, $Val = false) {
    Lc.f("ulozPolozku");
    this.refresh();

    Lc.log("Kosik.polozky", this.polozky);

    this.polozky[$priceId] = $Val;
    ls.set("ladzo.cz/Kosik/polozky", this.polozky);

    //--pokud je iframe, zavreme okno
    if (Top.jeIframe) {
      Lc.h("zavřeni iframu");
      Lc.h("showMessage");
      window.parent.showMessage(
        "Produkt byl přidán do konfigurátoru a košíku",
        "success",
        undefined,
        undefined,
        false,
        "#dvMessage"
      );

      if (window.parent.location.pathname.startsWith("/kosik/")) {
        Lc.h("refresh content");

        window.parent.shoptet.cart.getCartContent(true, function() {
          console.log(11);
        });
      }

      window.parent.$.fancybox.close();
      //window.parent.$.magnificPopup.close();

      return true;
    }

    Lc.t("ladzo:aktualizaceWidgetuKosiku");
    $(document).trigger("ladzo:aktualizaceWidgetuKosiku");
  },

  vytvorObjektProduktuZFormulare: function($form, $priceId) {
    let $formData = $form.serializeArray();
    let $objForm = array_column($formData, "value", "name");

    let $url = get(detail.DetailProduktu, "parametry.DruhZbozi_url") || false;
    Lc.log("det", detail.DetailProduktu);
    Lc.log("url", $url);
    //--produkty bez parametru Druh zboží neukladat
    if (!$url) return false;

    $url = $url.split("?")[1];

    let $urlParams = new URLSearchParams($url);
    let $idFiltru = $urlParams.get(KF.Rucka._filterID) || false;
    if (!$idFiltru) return false;

    var arr = [];
    var $druhZbozi = false;
    //--zsikani vsech druhu zozi, pro ktere se dela konfigurace
    _.forEach(KF.urlAdresy, function($Val, $key) {
      let typ = KF[$key];
      if (typ._param.split(",").indexOf($idFiltru + "") > -1) {
        $druhZbozi = $key;
      }

      arr = _.concat(arr, typ._param.split(","));
    });

    if (arr.indexOf($idFiltru + "") == -1) {
      return false;
    }

    Lc.log("Druh zboží", $druhZbozi);
    Lc.log("$idFiltru", $idFiltru);

    Lc.log("detail.DetailProduktu", detail.DetailProduktu);

    let $objDl = $helper.get("shoptet.product");

    let $popisVarianty = false;
    if ($objDl.hasVariants) {
      $popisVarianty = $form
        .find('#simple-variants-select option[value="' + $priceId + '"]')
        .html();
    }

    if ($form.closest("body").hasClass("desktop")) {
      $objForm.obr = $form
        .find("div#wrap img")
        .attr("src")
        .replace("/orig/", "/related/");
    } else {
      $objForm.obr = $form
        .find(".p-image-wrapper .p-image  img:first")
        .attr("src")
        .replace("/big/", "/related/");
    }

    $objForm.name = $objDl.name;
    $objForm.popisVarianty = $popisVarianty;
    $objForm.druhZbozi = $druhZbozi;
    $objForm.urlProduktu = window.location.pathname;

    Lc.log("$objForm", $objForm);

    return $objForm;
  },

  loadEventsForDeleteInCart: function() {
    //--ShoptetCartUpdated
    //ShoptetCartDeleteCartItem   ShoptetCartDeleteCartItem
    //---momentalne pro sitotu davam pro vsechny operace v kosiku
    //getCartContent

    Lc.e("loadEventsForDeleteInCart");

    document["addEventListener"]("ShoptetCartDeleteCartItem", async args => {
      Lc.e("loadEventsForDeleteInCart", args);
      var cart = window.getShoptetDataLayer("cart");
      Lc.log("dataLayer cart", cart);

      this.smazPolozkyDleDatalayeruShoptetu();
      Kosik.aktualizujZavisle();
    });

    shoptet.cart.functionsForCart = function(form, response) {
      Lc.log("form", form);
      Lc.log("response", response);

      var mujForm = $(form);
      if (
        mujForm.attr("action") == "/action/Cart/deleteCartItem/" &&
        response.R200_OK == 200
      ) {
        let $priceId = mujForm.find('input[name="priceId"]').val();
        Lc.log("priceId", $priceId);
        Kosik.smazPolozku($priceId);

        Kosik.aktualizujZavisle();
      }

      //shoptet.cart.triggerCofidisCalc();
      shoptet.tracking.handleAction(form, response);
      if (
        typeof shoptet.config.showAdvancedOrder !== "undefined" &&
        !shoptet.config.orderingProcess.active
      ) {
        shoptet.cart.getAdvancedOrder();
      }
    };
  },

  /*
    document.addEventListener("ShoptetCartDeleteCartItem", function(e) {
      Lc.e("ShoptetCartDeleteCartItem");

      Lc.log("e", e);

      var target = $(e.target);
      Lc.log("target", target);
      let $priceId = target.find('input[name="priceId"]').val();

      Lc.log("priceId", $priceId);
      Kosik.smazPolozku($priceId);

      Kosik.aktualizujZavisle();
    });
  },
  */

  loadEventForAddItemToCart: function() {
    if (!KF.vybraneVolby()) return false;

    document.addEventListener("ShoptetCartAddCartItem", function(e) {
      Lc.e("ShoptetCartAddCartItem");

      var target = $(e.target);
      Lc.log("target", target);
      let $priceId = target.find('input[name="priceId"]').val();

      //Lc.log('obr',target.find('div#wrap img').attr('src'));

      Lc.log("priceId", $priceId);
      //let $objForm= Kosik.vytvorObjektProduktuZFormulare($('form#product-detail-form',$priceId));
      let $objForm = Kosik.vytvorObjektProduktuZFormulare(target, $priceId);
      Lc.log($objForm);
      if ($objForm) Kosik.ulozPolozku($priceId, $objForm);
    });
    /*
      document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function(e) {
           Lc.e('ShoptetDOMAdvancedOrderLoaded');

           let target = $(e.target);
           Lc.log('target',target);

           let $a=$(this).find('#cboxContent .btn-conversion');
           Lc.log('a',$a);

           Lc.log('a.text()',$a.text());


      });
      */
  }
};

Kosik._init();

export { Kosik };
